import fs from 'fs'
import path from 'path'

import React from 'react'
import Head from 'next/head'
import { Remark } from 'react-remark'
import clsx from 'clsx'

import { Header } from 'components/Header'
import { isNavigator, isWebview } from 'utils/browser'
import components from 'configs/remark-markdown-components'
import DesktopPageHeader from 'components/ResponsiveLayout/DesktopPageHeader'
import PageContainer from 'components/ResponsiveLayout/PageContainer'
import { usePolicyTnsDesktopView } from 'utils/hooks/usePolicyTnsDesktopView'

const title = 'Kebijakan Privasi Platform Ruang GTK'

export async function getStaticProps() {
  const filePath = path.join(process.cwd(), '/data/policy.md')
  const content = fs.readFileSync(filePath, 'utf-8')

  return {
    props: {
      content,
    },
  }
}

export default function PolicyPage({ content }: { content: string }) {
  const { isDesktop } = usePolicyTnsDesktopView()

  // Hydration-safe webview check
  const [isOpenedOnWebview, setIsOpenedOnWebview] = React.useState(true)
  React.useEffect(() => {
    setIsOpenedOnWebview(isNavigator ? isWebview() : true)
  }, [])

  if (isDesktop) {
    return (
      <div className="min-h-screen bg-surface-subdued">
        <Head>
          <title>{title}</title>
        </Head>
        <DesktopPageHeader
          breadcrumbItems={[{ label: title, href: null }]}
          breadcrumbClassName="bg-white"
        />
        <main className="w-full pb-14 bg-surface-subdued">
          <PageContainer className="max-w-3xl">
            {/* eslint-disable react/no-unknown-property */}
            <style jsx global>{`
              .policy-wrapper > p {
                text-align: justify;
              }
            `}</style>
            <div className="p-6 mt-6 leading-loose bg-white rounded-xl shadow-sm">
              <h1 className="text-2xl font-bold mb-4">{title}</h1>
              <p className="font-semibold mb-6">
                Terakhir diperbarui: 09/02/2026
              </p>
              <div className="policy-wrapper">
                <Remark rehypeReactOptions={{ components }}>{content}</Remark>
              </div>
            </div>
          </PageContainer>
        </main>
      </div>
    )
  }

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>

      {/* Mobile Header */}
      {!isOpenedOnWebview && (
        <Header
          title={title}
          hasBackButton
          hasOrnament
          variant="primary"
          bordered={false}
          iconLeftSrc="/icon/arrow-left-white.svg"
        />
      )}

      {/* eslint-disable react/no-unknown-property */}
      <style jsx global>{`
        .policy-wrapper > p {
          text-align: justify;
        }
      `}</style>
      <div
        className={clsx(
          'px-4 leading-loose pb-14',
          !isOpenedOnWebview ? 'pt-[4.5rem]' : 'pt-4' // Add top padding only if header is shown
        )}
      >
        <p className="font-semibold mb-4">Terakhir diperbarui: 09/02/2026</p>
        <div className="policy-wrapper">
          <Remark rehypeReactOptions={{ components }}>{content}</Remark>
        </div>
      </div>
    </>
  )
}

const PolicyLayout = ({ children }: { children: React.ReactNode }) => (
  <>{children}</>
)
PolicyPage.Layout = PolicyLayout
PolicyPage.layoutOpts = {
  hasBottomNav: false,
  hasHeader: false,
}
